const MetricCard = ({ label, value, note, tone = "neutral", valueClassName }) => <article className={`director-module1__metric director-module1__metric--${tone}`}>
  <span>{label}</span>
  <strong className={valueClassName} title={valueClassName && typeof value === "string" ? value : undefined}>{value}</strong>
  {note && <small>{note}</small>}
</article>;

export default MetricCard;
